// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "../Utilities/PaymentHelpersV2.bs.js";

function sendPromiseData(promise, key) {
  let executePromise = async () => {
    let response;
    try {
      response = await promise;
    } catch (exn) {
      response = null;
    }
    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
      [
        "response",
        response
      ],
      [
        "data",
        key
      ]
    ]);
  };
  executePromise();
}

function useMessageHandler(getMessageHandler) {
  React.useEffect(() => {
    let messageHandler = getMessageHandler();
    let setupMessageListener = param => {
      window.addEventListener("message", messageHandler);
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "preMountLoaderIframeMountedCallback",
          true
        ]]);
    };
    let cleanupMessageListener = param => {
      window.removeEventListener("message", messageHandler);
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "preMountLoaderIframeUnMount",
          true
        ]]);
    };
    let handleCleanUpEventListener = ev => {
      let dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
      if (Core__Option.isSome(dict["cleanUpPreMountLoaderIframe"])) {
        return cleanupMessageListener();
      }
    };
    let handleResendMountedCallback = ev => {
      let dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
      if (Core__Option.isSome(dict["requestPreMountLoaderMountedCallback"])) {
        return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
            "preMountLoaderIframeMountedCallback",
            true
          ]]);
      }
    };
    window.addEventListener("message", handleCleanUpEventListener);
    window.addEventListener("message", handleResendMountedCallback);
    setupMessageListener();
    return () => {
      cleanupMessageListener();
      window.removeEventListener("message", handleCleanUpEventListener);
      window.removeEventListener("message", handleResendMountedCallback);
    };
  }, []);
}

function getMessageHandlerV1Elements(sdkAuthorization, clientSecret, publishableKey, logger, customPodUri, endpoint, merchantHostname, isTestModeOpt, isSdkParamsEnabledOpt) {
  let isTestMode = isTestModeOpt !== undefined ? isTestModeOpt : false;
  let isSdkParamsEnabled = isSdkParamsEnabledOpt !== undefined ? isSdkParamsEnabledOpt : false;
  let match;
  if (isTestMode || isSdkParamsEnabled) {
    let mockResponse = {};
    match = [
      Promise.resolve(mockResponse),
      Promise.resolve(mockResponse),
      Promise.resolve(mockResponse)
    ];
  } else {
    match = [
      PaymentHelpers$OrcaPaymentPage.fetchSessions(clientSecret, publishableKey, undefined, undefined, logger, customPodUri, endpoint, undefined, merchantHostname, Primitive_option.some(sdkAuthorization)),
      PaymentHelpers$OrcaPaymentPage.fetchSdkConfigs(clientSecret, publishableKey, logger, customPodUri, endpoint, Primitive_option.some(sdkAuthorization)),
      PaymentHelpers$OrcaPaymentPage.fetchClientList(clientSecret, publishableKey, logger, customPodUri, endpoint, undefined, Primitive_option.some(sdkAuthorization))
    ];
  }
  let clientListPromise = match[2];
  let sdkConfigsPromise = match[1];
  let sessionTokensPromise = match[0];
  return ev => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
    if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendSessionTokensResponse")) {
      return sendPromiseData(sessionTokensPromise, "session_tokens");
    } else if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendSdkConfigsResponse")) {
      return sendPromiseData(sdkConfigsPromise, "sdk_configs");
    } else if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendClientListResponse")) {
      return sendPromiseData(clientListPromise, "client_list");
    } else {
      return;
    }
  };
}

function getMessageHandlerV2PMM(pmSessionId, logger, customPodUri, endpoint, sdkAuthorization) {
  let listPromise = PaymentHelpersV2$OrcaPaymentPage.fetchPaymentManagementList(pmSessionId, endpoint, Primitive_option.some(logger), customPodUri, sdkAuthorization);
  return ev => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
    if (Utils$OrcaPaymentPage.isKeyPresentInDict(dict, "sendPaymentManagementListResponse")) {
      return sendPromiseData(listPromise, "payment_management_list");
    }
  };
}

function PreMountLoader$PreMountLoaderForElements(props) {
  let __isSdkParamsEnabled = props.isSdkParamsEnabled;
  let __isTestMode = props.isTestMode;
  let customPodUri = props.customPodUri;
  let merchantHostname = props.merchantHostname;
  let endpoint = props.endpoint;
  let clientSecret = props.clientSecret;
  let sdkAuthorization = props.sdkAuthorization;
  let publishableKey = props.publishableKey;
  let logger = props.logger;
  let __isTestMode_value = __isTestMode !== undefined ? __isTestMode : false;
  let __isSdkParamsEnabled_value = __isSdkParamsEnabled !== undefined ? __isSdkParamsEnabled : false;
  useMessageHandler(() => getMessageHandlerV1Elements(sdkAuthorization, clientSecret, publishableKey, logger, customPodUri, endpoint, merchantHostname, __isTestMode_value, __isSdkParamsEnabled_value));
  return null;
}

let PreMountLoaderForElements = {
  make: PreMountLoader$PreMountLoaderForElements
};

function PreMountLoader$PreMountLoaderForPMMElements(props) {
  let sdkAuthorization = props.sdkAuthorization;
  let pmSessionId = props.pmSessionId;
  let customPodUri = props.customPodUri;
  let endpoint = props.endpoint;
  let logger = props.logger;
  useMessageHandler(() => getMessageHandlerV2PMM(pmSessionId, logger, customPodUri, endpoint, sdkAuthorization));
  return null;
}

let PreMountLoaderForPMMElements = {
  make: PreMountLoader$PreMountLoaderForPMMElements
};

function PreMountLoader(props) {
  let __isSdkParamsEnabled = props.isSdkParamsEnabled;
  let __isTestMode = props.isTestMode;
  let customPodUri = props.customPodUri;
  let endpoint = props.endpoint;
  let clientSecret = props.clientSecret;
  let sdkAuthorization = props.sdkAuthorization;
  let publishableKey = props.publishableKey;
  let __isTestMode_value = __isTestMode !== undefined ? __isTestMode : false;
  let __isSdkParamsEnabled_value = __isSdkParamsEnabled !== undefined ? __isSdkParamsEnabled : false;
  let logger = HyperLogger$OrcaPaymentPage.make(props.sessionId, "Loader", clientSecret, publishableKey, undefined);
  if (props.hyperComponentName === "Elements") {
    return JsxRuntime.jsx(PreMountLoader$PreMountLoaderForElements, {
      logger: logger,
      publishableKey: publishableKey,
      sdkAuthorization: sdkAuthorization,
      clientSecret: clientSecret,
      endpoint: endpoint,
      merchantHostname: props.merchantHostname,
      customPodUri: customPodUri,
      isTestMode: __isTestMode_value,
      isSdkParamsEnabled: __isSdkParamsEnabled_value
    });
  } else {
    return JsxRuntime.jsx(PreMountLoader$PreMountLoaderForPMMElements, {
      logger: logger,
      endpoint: endpoint,
      customPodUri: customPodUri,
      pmSessionId: props.pmSessionId,
      sdkAuthorization: sdkAuthorization
    });
  }
}

let make = PreMountLoader;

export {
  sendPromiseData,
  useMessageHandler,
  getMessageHandlerV1Elements,
  getMessageHandlerV2PMM,
  PreMountLoaderForElements,
  PreMountLoaderForPMMElements,
  make,
}
/* react Not a pure module */
